import React from 'react';

import { useCurrentUser } from '@application/customer';
import { AppLayout } from '@ui/core/AppLayout';
import { Loading } from '@ui/core/page/Loading';
import { Error } from '@ui/core/page/Error';
import type { Customer } from '@domain/Customer';

const userSelector = (customer: Customer) => {
  const { profile, accountSettings } = customer;
  const [profileImage] = profile?.profileImage || [];
  const [occupation] = profile?.ocupations || [];

  return {
    userName: profile?.displayName,
    userAvatarUrl: profileImage?.url,
    userCompany: occupation?.headline,
    userEmail: accountSettings?.email?.active,
  };
};

const BaseScreen = ({ children }) => {
  const { loading, currentUser, error } = useCurrentUser(userSelector);
  if (loading) {
    return <Loading />;
  }

  if (error) {
    return <Error />;
  }

  return <AppLayout headerProps={currentUser}>{children}</AppLayout>;
};

export { BaseScreen };
